/**
 * Section-form search: autocomplete with mobile-style result cards.
 * Uses /findTypes.php with is_ankauf=1 (sell) or is_repair=1 (repair).
 */
import {
    createSearchResultCard,
    SEARCH_DEBOUNCE_MS,
    SEARCH_FORM_TYPE_REPAIR,
    SEARCH_MIN_CHARS,
} from './search-result-card';

const MAX_RESULTS = 5;

function initSectionFormSearch() {
    const searchInstances = [];

    document.querySelectorAll('.js_section_form').forEach(function (section) {
        const searchbar = section.querySelector('.searchbar');
        const input = searchbar ? searchbar.querySelector('.searchbar__input') : null;
        if (!input) {
            return;
        }

        const formType = section.dataset.formType;
        const endpointBase = formType === SEARCH_FORM_TYPE_REPAIR
            ? '/findTypes.php?is_repair=1&big_design_tiles=1&query='
            : '/findTypes.php?is_ankauf=1&big_design_tiles=1&query=';

        const resultsContainer = section.querySelector('.js_section_form_results');
        if (!resultsContainer) {
            return;
        }

        function close() {
            resultsContainer.innerHTML = '';
            resultsContainer.hidden = true;
        }

        function render(results) {
            resultsContainer.innerHTML = '';
            let shown = 0;
            results.forEach(function (item) {
                if (shown >= MAX_RESULTS) {
                    return;
                }
                resultsContainer.appendChild(createSearchResultCard(item, formType));
                shown++;
            });
            resultsContainer.hidden = shown === 0;
        }

        let debounceTimer = null;
        let abortController = null;

        input.addEventListener('input', function () {
            if (debounceTimer) { clearTimeout(debounceTimer); }
            const query = input.value.trim();
            if (query.length < SEARCH_MIN_CHARS) {
                if (abortController) { abortController.abort(); }
                close();
                return;
            }
            debounceTimer = setTimeout(function () {
                if (abortController) { abortController.abort(); }
                abortController = new AbortController();
                fetch(endpointBase + encodeURIComponent(query), { signal: abortController.signal })
                    .then(function (resp) {
                        if (!resp.ok) { throw new Error('HTTP ' + resp.status); }
                        return resp.json();
                    })
                    .then(function (data) { render(data.suggestions || []); })
                    .catch(function (err) {
                        if (err.name !== 'AbortError') { console.error(err); }
                    });
            }, SEARCH_DEBOUNCE_MS);
        });

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                input.value = '';
                close();
            }
        });

        const closeBtn = searchbar.querySelector('.js_searchbar_close');
        if (closeBtn) {
            closeBtn.addEventListener('click', close);
        }

        searchInstances.push({ searchbar: searchbar, resultsContainer: resultsContainer, close: close });
    });

    if (searchInstances.length > 0) {
        document.addEventListener('click', function (e) {
            searchInstances.forEach(function (instance) {
                if (!instance.searchbar.contains(e.target) && !instance.resultsContainer.contains(e.target)) {
                    instance.close();
                }
            });
        });
    }
}

/**
 * Verkaufen/Tauschen switch toggle.
 */
function initSectionFormSwitch() {
    document.addEventListener('click', function (e) {
        const switchBtn = e.target.closest('.js_section_form_switch');
        if (!switchBtn) {
            return;
        }

        const section = switchBtn.closest('.js_section_form');
        if (!section) {
            return;
        }

        const targetView = switchBtn.dataset.view;

        section.querySelectorAll('.js_section_form_switch').forEach(function (btn) {
            const isActive = btn === switchBtn;
            btn.classList.toggle('category_switch__item--active', isActive);
            btn.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('.js_section_form_view').forEach(function (view) {
            view.hidden = view.dataset.view !== targetView;
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initSectionFormSearch();
    initSectionFormSwitch();
});
